import React from 'react';
import createThemedComponent from '../../../theming/utils/createThemedComponent';
import { GenericIconButton } from './IconButton.styles';
/**
 *
 * Themeable IconButton component that allows the user to wrap around an icon and provide a link to.
 *
 * Example usage:
 *
 *```js
 * import { IconButton } from '@minerva-analytics/pantheon';
 *
 * <IconButton href="website.net" target="__blank">
 *   <YourIcon />
 * </IconButton>
 * ```
 *
 * **Default Styles**
 *
 *To view the `IconButton` styling directly, see [IconButton.styles.js](https://git.cogolo.net/minerva/pantheon/blob/master/src/components/widgets/IconButton/IconButton.styles.js)
 *
 */

export var IconButtonComponent = function IconButtonComponent(props) {
  return /*#__PURE__*/React.createElement(GenericIconButton, props);
};
var IconButton = createThemedComponent('IconButton', GenericIconButton);
export default IconButton;